//filter types constant
export const subscriptionStatus = {
  ACTIVE: 'ACTIVE',
  OVERDUE: 'DEFAULT',
  PROCESSED: 'PROCESSED'
}

export const businessNature = {
  ABO: 'AmwayBusinessNature_1',
  APC: 'AmwayBusinessNature_3'
}

export const ownership = {
  SELF: 'me',
  OTHER: 'other'
}

export const nameSort = {
  A_TO_Z: "name-asc",
  Z_TO_A: "name-desc",
}

export const lineLevelSort = {
  LOW_TO_HIGH: "line-level-asc",
  HIGH_TO_LOW: "line-level-desc"
}

export const benefitStatus = {
  AVAILABLE: "available",
  SCHEDULED: "scheduled",
  EXPIRED: "expired",
  COMPLETED: "completed",
  IN_REVIEW: "in_review"
}

export const quickFilter = {
  ALL: "all",
  SUBSCRIPTION_DEFAULT: "subscription-default",
  SERVICE_SCHEDULED: "service-scheduled",
  SERVICE_AVAILABLE: "service-available"
}

export default { subscriptionStatus, businessNature, ownership, nameSort, benefitStatus, quickFilter, lineLevelSort }
